import React from "react";
import { useAppSelector } from "../../../store/reduxHooks";
import { SELECT_REQUEST_ALL_DATA } from "../../../store/selectors/requestAppSelector";
import { getPurchaseType } from "../../../utils/utilities/GetPurchaseType";
import { PriceSpace } from "../../../utils/utilities/PraiceSpace";
import { formattedDate } from "../../../utils/utilities/FormattedDate";
import { PurchaseInfo } from "./PurchaseInfo/PurchaseInfo";
import { SELECT_PROFILE_ROLE } from "../../../store/selectors/profileSelectors";
import { USER } from "../../../types/indexTypeEnum";
import { IPurchaseInfoItem } from "../../../interfaces/IPurchaseInfoItem";
import { IPurchaseInfoListProps } from "../../../interfaces/props/IPurchaseInfoListProps";
import { PurchaseInfoListWithComponentRow } from "../../../interfaces/PurchaseInfoListWithComponentRow";
import { getRoleName } from "../../../utils/utilities/getRoleName";
import { formatPrice } from "../../../utils/utilities/formatPrice";

/**
 * Компонент отображает список информации о закупке.
 *
 * @param {IPurchaseInfoListProps} props - Свойства компонента
 * @param {FormInstance<IPurchaseInfoFormValues>} props.formChange - Экземпляр формы для изменения
 */
export function PurchaseInfoList(props: IPurchaseInfoListProps): JSX.Element {
  const { formChange } = props;
  const DATA = useAppSelector(SELECT_REQUEST_ALL_DATA);
  const userRole = useAppSelector(SELECT_PROFILE_ROLE);
  const {
    purchase,
    total_sum,
    organization,
    purchase_lot,
    start_bg_at,
    finish_bg_at,
    agent,
  } = DATA;

  const isClosedAuction = purchase?.is_closed ? "Закрытый" : "Открытый";
  const isReprovisiAnuction = purchase?.is_reprovision ? "Да" : "Нет";
  const isSoleSupplierAnuction = purchase?.is_sole_supplier ? "Да" : "Нет";
  const isInitialpriceContact = purchase_lot?.initial_price
    ? purchase_lot?.initial_price
    : "-";
  const isTtotalSumContact = total_sum ? total_sum : "-";
  const isSumAvansContact = purchase_lot?.sum_avance
    ? purchase_lot?.sum_avance
    : "-";
  const isIndisputable = purchase?.is_indisputable ? "Да" : "Нет";
  const numberLot = purchase_lot?.number_lot ? purchase_lot?.number_lot : "-";
  const isStartBg = start_bg_at !== null ? formattedDate(start_bg_at) : "-";
  const isFinishBg = finish_bg_at !== null ? formattedDate(finish_bg_at) : "-";
  const sum_bg = DATA?.application_sum_bg;
  const purchaseTotalAt = purchase?.purchase_total_at;
  const purchaseEndAt = purchase?.purchase_end_at
    ? purchase?.purchase_end_at
    : "-";
  const sum_bg_execution = purchase_lot?.sum_bg_execution
    ? purchase_lot?.sum_bg_execution
    : "-";
  const sumBgObligation = purchase_lot?.sum_bg_obligation
    ? purchase_lot?.sum_bg_obligation
    : "-";

  let purchaseInfoList: PurchaseInfoListWithComponentRow<IPurchaseInfoItem> = {
    purchase: [
      {
        title: "Закупка",
      },
      {
        name: getPurchaseType(purchase),
        value: (
          <a href={DATA.link} target="_blank" rel="noopener noreferrer">
            {purchase.purchase_number}
          </a>
        ),
        type: { link: "div", color: "#3c79ff" },
        typeTitle: "ghost",
      },
      {
        name: "Сумма БГ",
        value: formatPrice(sum_bg),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },

      {
        name: "Предмет контракта",
        value: purchase.subject_contract,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Номер лота",
        value: `${numberLot}`,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Дата проведения аукциона",
        value: formattedDate(purchaseTotalAt),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Окончание подачи заявок",
        value: formattedDate(purchaseEndAt),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
    client: [
      {
        title: "Клиент",
      },
      {
        name: "Наименование организации",
        value: organization?.name,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "ИНН",
        value: `${organization?.inn}`,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
    customer: [
      {
        title: "Заказчик",
      },
      {
        name: "Наименование организации",
        value: `${purchase_lot?.name_customer}`,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "ИНН",
        value: `${purchase_lot?.inn_customer}`,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
    auction: [
      {
        title: "Аукцион",
      },
      {
        name: "Тип Аукцион",
        value: isClosedAuction,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Переобеспечение",
        value: isReprovisiAnuction,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Сумма обеспечения заявки",
        value: PriceSpace(sum_bg),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Сумма обеспечения гарантийные обязательства",
        value: PriceSpace(sumBgObligation),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Бесспорное списание средств",
        value: isIndisputable,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Единственный поставщик",
        value: isSoleSupplierAnuction,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
    price_contact: [
      {
        title: "Цена контракта",
      },
      {
        name: "Начальная цена контракта",
        value: PriceSpace(isInitialpriceContact),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Итоговая цена контракта",
        value: PriceSpace(isTtotalSumContact),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Сумма аванса по контракту",
        value: PriceSpace(isSumAvansContact),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Сумма обеспечения на исполнение (контракт)",
        value: PriceSpace(sum_bg_execution),
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
    start_end_bg: [
      {
        title: "Начало и окончание БГ",
      },
      {
        name: "Дата начала",
        value: isStartBg,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
      {
        name: "Дата окончания",
        value: isFinishBg,
        type: { link: "div", color: "black" },
        typeTitle: "ghost",
      },
    ],
  };

  if (userRole === USER.SUPPORT_ADMIN) {
    purchaseInfoList = Object.assign(
      {
        author: [
          {
            title: "Автор заявки",
          },
          {
            name: "Роль",
            value: getRoleName(agent.type),
            type: { link: "div", color: "black" },
            typeTitle: "ghost",
          },
          {
            name: "ФИО",
            value: `${agent.surname || ""} ${agent.name || ""} ${agent.patronymic || ""}`,
            type: { link: "div", color: "black" },
            typeTitle: "ghost",
          },
        ],
      },
      purchaseInfoList,
    );
  }

  return (
    <>
      <PurchaseInfo info={purchaseInfoList} formChange={formChange} />
    </>
  );
}
